export default __webpack_public_path__ + "static/media/doodle-down.f610efa5.png";